import { type ReactNode } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Card } from "../../primitives";
import { buildSummaryLink } from "../utils/summary.utils";

export type SummaryCardSectionProps = {
	header: string;
	to?: { pathname: string; section: string };
	children: ReactNode;
};

export const SummaryCardSection = ({ header, to, children }: SummaryCardSectionProps) => {
	const [searchParams] = useSearchParams();

	return (
		<Card className="flex flex-col">
			<Card.Header className="h-[50px] px-5 py-0">
				<Card.Title>
					{to ? <Link to={buildSummaryLink(to, searchParams)}>{header}</Link> : header}
				</Card.Title>
			</Card.Header>
			<Card.Body surface="gray" className="flex flex-1 flex-col gap-7 px-[30px] py-[25px]">
				{children}
			</Card.Body>
		</Card>
	);
};
